<script>

import { ButtonAlignCenter, ButtonFlashRadial, ButtonIconPositionHugRight, ButtonIconPositionShiftLeft, ButtonIconActiveHeight } from '@kit/components/IconButton.vue'

export const baseGalleryButton = {
  foreground: {
    active:   "#FFFFFF",
    inactive: "#AAAAAA",
    flash:    "#FFFFFF",
    loading:  "#FFFFFF" 
  },
  background: { 
    padding:      "10px",
    none: true    
  },
  iconPosition: ButtonIconPositionShiftLeft,
  align: ButtonAlignCenter,
  allowPropagate: false,
  loader: {
    fill:"#CCCCCC", 
    wheel: {
      gif:"Spinner-0.4s-310px-ffffff-transparent",
      spinnerStyle:"width:120%; height:120%; top:-10%; left:-10%; background-size:contain; background-position:center; background-repeat:no-repeat; position:absolute;"
    }
  }
}

export const roundCloseButton = {
  ...baseGalleryButton, 
  icon:"rounded-close-x_50", 
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px"
  },
}

export const leftButton = {
  ...baseGalleryButton,
  icon:"rounded-single-chevron-left",
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "40px"
  }
}

export const rightButton = {
  ...baseGalleryButton,
  icon:"rounded-single-chevron-right",
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "40px"
  }
}

  export const greenButton = {
    foreground: {
      active:   "#FFFFFF",
      inactive: "#FFFFFF",
      flash:    "#FFFFFF",
      loading:  "#FFFFFF" 
    },
    background: {
      active:       "#447340",
      inactive:     "#CCCCCC",
      flash:        "#94cc8f", 
      loading:      "#CCCCCC",
      hover:        "#4c8c46",  
      borderRadius: "3px",   
      padding:      "10px"     
    },
    iconPosition: ButtonIconPositionShiftLeft,
    align: ButtonAlignCenter,
    flash: ButtonFlashRadial,
    allowPropagate: false,
    loader: {
      fill:"#CCCCCC", 
      wheel: {
        gif:"Spinner-0.4s-310px-ffffff-transparent",
        spinnerStyle:"width:120%; height:120%; top:-10%; left:-10%; background-size:contain; background-position:center; background-repeat:no-repeat; position:absolute;"
      }
    }
  }

  export const redButton = {
    ...greenButton,
    background: {
      active:       "#d2301e",
      inactive:     "#CCCCCC",
      flash:        "#f69a90", 
      loading:      "#CCCCCC",
      hover:        "#FF0000",  
      borderRadius: "5px",   
      padding:      "10px"    
    }
  }


  export const blueButton = {
    foreground:  "#FFFFFF",
    background: {
      active:       "#4b6a9eff",
      inactive:     "#CCCCCC",
      flash:        "#669cfa", 
      loading:      "#CCCCCC",
      hover:        "#587ebf",  
      borderRadius: "4px",   
      padding:      "10px"     
    },
    textStyle: 'font-weight: bold; color:white;',
    iconPosition: ButtonIconPositionShiftLeft,
    align: ButtonAlignCenter,
    flash: ButtonFlashRadial,
    allowPropagate: false,
    loader: {
      fill:"#CCCCCC", 
      wheel: {
        gif:"Spinner-0.4s-310px-ffffff-transparent",
        spinnerStyle:"width:120%; height:120%; top:-10%; left:-10%; background-size:contain; background-position:center; background-repeat:no-repeat; position:absolute;"
      }
    }
  }

  export const navMainSearchButton = { 
    ...blueButton, 
    icon:"rounded-magnifying-glass",
    iconStyle:"transform:rotate(45deg)",
    outerClasses:"sb sb-explicit fbicc-nav-main-search-iconbutton",
    background: {  
      none: true,
      padding:      "10px", 
      borderRadius: "0px"    
    },
    foreground: "#FFFFFF", 
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: '30px'
    },
  }

  export const navSearchWidgetButton = { 
    ...blueButton, 
    icon:"rounded-magnifying-glass",
    iconStyle:"transform:rotate(45deg)",
    outerClasses:"sb-explicit fbicc-nav-main-search-widget-button",
    foreground: "#FFFFFF",
    background: {
      ...blueButton.background, 
      borderRadius: "4px",  
      padding:      "5px",   
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: '20px'
    },
  }

  export const prevNextSearchResultsButton = { 
    ...blueButton,
    background: { 
      ...blueButton.background, 
      padding:"7px 20px 7px 20px",
      borderRadius:"3px"
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: '25px'  
    } 
  }


  export const blueDownloadPDFButton = {
    ...blueButton, 
    icon:"download-rounded",
    textStyle: 'font-weight: bold',
    iconPosition: ButtonIconPositionHugRight,
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: '25px'   
    }
  }


  export const formSubmitButtonBlue = {
    ...blueButton, 
    iconFromProject:false,
    icon:"rounded-check_30",
    background: {  
      ...blueButton.background,
      padding:'20px'   
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: "20px",
      borderRadius:"3px"
    }
  }


  export const socialMediaButton = {
    foreground: "#163E6F",
    background: {
      active:       "#849CB3",
      inactive:     "#CCCCCC",
      flash:        "#42b6cf", 
      loading:      "#CCCCCC",
      hover:        "#388fa1",
      borderRadius: "50%",   
      padding:      "3px"     
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: '50px'
    },
    iconFromProject: true,
    flash: ButtonFlashRadial,
    allowPropagate: false,
  }


  export const galleryLeftButton = {
    ...blueButton,
    iconFromProject: false,
    icon: "rounded-single-chevron-left",
    foreground: "#ffffff",
    background: {
      active: "rgba(0,0,0,0.6)",
      inactive: "rgba(60,60,60,0.6)",
      hover: "rgba(80, 123, 251, 0.6)",
      flash: "#fff",
      padding: "40px",
      borderRadius: "2px"
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: "20px"
    }
  }

  export const galleryRightButton = {
    ...blueButton,
    iconFromProject: false,
    icon: "rounded-single-chevron-right",
    foreground: "#ffffff",
    background: {
      active: "rgba(0,0,0,0.6)",
      inactive: "rgba(60,60,60,0.6)",
      hover: "rgba(80, 123, 251, 0.6)",
      flash: "#fff",
      padding: "40px",
      borderRadius: "2px"
    },
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: "20px"
    }
  }

  export const roundCloseButtonBlue = {
    ...blueButton, 
    icon:"rounded-close-x_50", 
    iconFromProject:false,
    iconDimension: {
      style: ButtonIconActiveHeight,
      active: "20px"
    },
    width:"50px",
    height:"50px"
  }

export default { "name":"theme-buttons" }
</script>







  